import { render, staticRenderFns } from "./CustomerRegisteredProspect.vue?vue&type=template&id=3998e8a7&scoped=true"
import script from "./CustomerRegisteredProspect.vue?vue&type=script&lang=js"
export * from "./CustomerRegisteredProspect.vue?vue&type=script&lang=js"
import style0 from "./CustomerRegisteredProspect.vue?vue&type=style&index=0&id=3998e8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998e8a7",
  null
  
)

export default component.exports